import styled from 'styled-components';
import { useState } from 'react';

import { Label, Container } from './Styles';

const AddContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 28px;
  height: 28px;
  margin: 5px 0;
  cursor: pointer;
  border-radius: 22px;
  border: 2px solid var(--darkGrey);

  svg {
    min-width: 14px;
    height: auto;
    path {
      fill: 'var(--darkGrey)';  
    }
  }
`;

const AddBtn = ({ clickEvent }) => {
  const [active, setActive] = useState(true);

  return (
    <Container
      onClick={() => {
        setActive(false);
        if (active) clickEvent();
      }}
      disabled={active}
    >
      <AddContainer>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path
            d="M18.333,10v8.333H10v3.333h8.333V30h3.333V21.667H30V18.333H21.667V10Z"
            transform="translate(-10 -10)"
          />
        </svg>
      </AddContainer>
      <Label>Add</Label>
    </Container>
  );
};

export default AddBtn;
